import {
  Facet,
  FacetOption,
  FacetsAdapterResult,
} from '../../../collaborators/fetch-products/new-contract/types';
import getSizeVariants from '../../size-variants';
import { adaptStyle } from '../../flex-facets-adapter/adapt-function/adapt-size';
import adaptGrouping from '../../flex-facets-adapter/adapt-function/adapt-size/adapt-grouping';
import flattenSize from '../../../adapters/size-facet-helper';
import config from '../../config';

const FACET_IDENTIFIER = 'name';

const getAppliedValues = (facet: FacetOption) =>
  facet.selectedSizes && facet.selectedSizes.length > 0
    ? facet.selectedSizes
    : [];

const hasContent = (array: any) => Array.isArray(array) && array.length > 0;

const getLength = (flattenedSize: FacetOption) => {
  const length = flattenedSize?.selectedSizes?.length;
  return length ?? 0;
};

const sizeFacetAdapter = (facets: Facet[]): FacetsAdapterResult => {
  const facetOptions: FacetOption[] = facets
    .filter((facet: Facet) => facet.type === 'complex')
    .map((facet: Facet) => {
      return {
        ...(config[facet.name] ?? {}),
        isActive: 'true',
        type: facet.type,
        name: facet.name,
        searchFacetId: facet.name,
        displayName: facet.localeName,
        selectionType: facet.name,
        searchFacetName: facet.localeName,
        searchFacetOptionGroupList: adaptGrouping(
          facet.options,
          FACET_IDENTIFIER
        ).map((facetData: Facet) => adaptStyle(facetData, FACET_IDENTIFIER)),
      };
    });

  const flattenedSize = flattenSize(facetOptions[0]);
  const hasTags = getLength(flattenedSize) > 0;
  const sizeVariants = getSizeVariants(flattenedSize);
  const appliedValues = getAppliedValues(flattenedSize);

  const options = hasContent(flattenedSize.sizeOptions)
    ? [
        {
          ...facetOptions[0],
          sizeVariants,
          appliedValues,
        },
      ]
    : [];

  return {
    hasTags,
    facetOptions: options,
  };
};

export default sizeFacetAdapter;
